function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var AdminKeyUI = require('./adminkey');
var AdminSetup = require('./setup');
var AdminOverviewUI = require('./overview');
var AdminModulesUI = require('./modules');
var AdminPeersUI = require('./peers');
var AdminDatabaseUI = require('./database');
var AdminBlocksUI = require('./blocks');
var AdminMempoolUI = require('./mempool');
var AdminFaucetUI = require('./faucet');
var AdminMain = /*#__PURE__*/function () {
  function AdminMain(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.saito-container';
    _classCallCheck(this, AdminMain);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.mode = '';
    this.current_view = 'overview';
    this.shell_rendered = false;
    this.adminkey_ui = new AdminKeyUI(app, mod);
    this.setup_ui = new AdminSetup(app, mod);
    this.overview_ui = new AdminOverviewUI(app, mod);
    this.modules_ui = new AdminModulesUI(app, mod);
    this.peers_ui = new AdminPeersUI(app, mod);
    this.database_ui = new AdminDatabaseUI(app, mod);
    this.blocks_ui = new AdminBlocksUI(app, mod);
    this.mempool_ui = new AdminMempoolUI(app, mod);
    this.faucet_ui = new AdminFaucetUI(app, mod);
  }
  return _createClass(AdminMain, [{
    key: "hasAdminKey",
    value: function hasAdminKey() {
      return !need_to_set_key;
    }
  }, {
    key: "isSetupComplete",
    value: function isSetupComplete() {
      var _this$mod$server_info;
      if (this.hasAdminKey()) {
        return true;
      }
      if (this.setup_ui.use_existing_config) {
        return true;
      }
      if ((_this$mod$server_info = this.mod.server_info) !== null && _this$mod$server_info !== void 0 && (_this$mod$server_info = _this$mod$server_info.options) !== null && _this$mod$server_info !== void 0 && _this$mod$server_info.defaultModule) {
        return true;
      }
      if (typeof default_module !== 'undefined' && default_module) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.current_view;
      if (!this.hasAdminKey()) {
        this.mode = 'adminkey';
        this.shell_rendered = false;
        this.adminkey_ui.render();
        return;
      }
      if (!this.isSetupComplete() || this.setup_ui.showing_recompile) {
        if (this.mode !== 'setup') {
          this.mode = 'setup';
          this.shell_rendered = false;
          this.setup_ui.render();
        }
        return;
      }
      this.mode = 'app';
      this.current_view = view;
      this.renderShell();
      this.showPage(view);
      if (view === 'overview') {
        this.overview_ui.render();
      }
      if (view === 'modules') {
        this.modules_ui.render();
      }
      if (view === 'peers') {
        this.peers_ui.render();
      }
      if (view === 'database') {
        this.database_ui.render();
      }
      if (view === 'blocks') {
        this.blocks_ui.render();
      }
      if (view === 'mempool') {
        this.mempool_ui.render();
      }
      if (view === 'faucet') {
        this.faucet_ui.render();
      }
    }
  }, {
    key: "renderShell",
    value: function renderShell() {
      if (this.shell_rendered && document.querySelector('.saito-admin-main')) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(MainTemplate(this.app, this.mod), this.container);
      this.shell_rendered = true;
      this.attachEvents();
    }
  }, {
    key: "showPage",
    value: function showPage(view) {
      document.querySelectorAll('.admin-page').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelectorAll('.saito-admin-nav-item').forEach(function (el) {
        el.classList.remove('active');
      });
      var page = document.querySelector(".admin-page.admin-".concat(view));
      if (page) {
        page.style.display = 'block';
      }
      var nav = document.querySelector(".saito-admin-nav-item[data-admin-view=\"".concat(view, "\"]"));
      if (nav) {
        nav.classList.add('active');
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      document.querySelectorAll('[data-admin-view]').forEach(function (el) {
        el.onclick = function (e) {
          var view = e.currentTarget.getAttribute('data-admin-view');
          _this.render(view);
        };
      });
    }
  }]);
}();
module.exports = AdminMain;